import React, { useCallback, useEffect, useReducer, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import {
  getCurrentAccount,
  refreshCurrentAccountWrapperInFunctionalComponent
} from '../services/session/sessionState'
import { getOrderTrackingByCustomer } from '../api/orderTracking.service'

export const OrderTrackingContext = React.createContext(null)

const OrderTrackingProvider = (props) => {
  const [route, setRoute] = useState({})
  const [loading, setLoading] = useState(false)

  const [, forceUpdate] = useReducer((x) => x + 1, 0)
  useEffect(() => {
    refreshCurrentAccountWrapperInFunctionalComponent(forceUpdate, props)
    const interval = setInterval(() => {
      const currentAccount = getCurrentAccount()

      if (!!currentAccount && !!currentAccount.id) {
        load(getCurrentAccount().id)
        clearInterval(interval)
      }
    }, 1000)
  }, [])

  const load = useCallback(async (customerId) => {
    try {
      setLoading(true)
      const { data } = await getOrderTrackingByCustomer(customerId)
      setRoute(data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  })

  const { children } = props
  return (
    <OrderTrackingContext.Provider
      value={{
        route,
        setRoute,
        loading,
        load
      }}
    >
      <ToastContainer />
      {children}
    </OrderTrackingContext.Provider>
  )
}

export const withOrderTrackingContext = (Component) => (props) => (
  <OrderTrackingContext.Consumer>
    {(context) => <Component orderTrackingContext={context} {...props} />}
  </OrderTrackingContext.Consumer>
)

export default OrderTrackingProvider
